import * as React from 'react'
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ToggleButton,
  ToggleButtonGroup,
  Button,
} from '@mui/material'
import { fetchEnabledTenants } from '../../../services/tenantService'

const getTenantOptionLabel = tenant =>
  tenant?.fullName ||
  tenant?.nombre_completo ||
  tenant?.nombreCompleto ||
  tenant?.name ||
  tenant?.nombre ||
  'Sin nombre'

const SearchFilter = ({ filters, onChange, onClear }) => {
  const [tenants, setTenants] = React.useState([])

  React.useEffect(() => {
    fetchEnabledTenants().then(list => setTenants(list || []))
  }, [])

  const handleCodesChange = e => {
    onChange({ ...filters, codes: e.target.value })
  }

  const handleTenantChange = e => {
    onChange({ ...filters, tenantId: e.target.value })
  }

  const handleHabilitadoChange = (_, value) => {
    if (value === null) return
    onChange({ ...filters, habilitado: value })
  }

  const handleCorreccionAplicadaChange = e => {
    onChange({ ...filters, correccionAplicada: e.target.value })
  }

  return (
    <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center', mb: 1.5 }}>
      <TextField
        size="small"
        label="Código(s)"
        placeholder="BLTE.S1.4, BLTE.S1.5"
        value={filters.codes}
        onChange={handleCodesChange}
        sx={{ minWidth: 200 }}
      />

      <FormControl size="small" sx={{ minWidth: 260 }}>
        <InputLabel>Tenant</InputLabel>
        <Select value={filters.tenantId} onChange={handleTenantChange} label="Tenant">
          <MenuItem value="">Todos</MenuItem>
          {tenants.map(t => (
            <MenuItem key={t.id} value={t.id}>
              {getTenantOptionLabel(t)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <ToggleButtonGroup
        size="small"
        exclusive
        value={filters.habilitado}
        onChange={handleHabilitadoChange}>
        <ToggleButton value="all">Todos</ToggleButton>
        <ToggleButton value="true">Habilitados</ToggleButton>
        <ToggleButton value="false">Deshabilitados</ToggleButton>
      </ToggleButtonGroup>

      <FormControl size="small" sx={{ minWidth: 220 }}>
        <InputLabel>Corrección (en revisión)</InputLabel>
        <Select
          value={filters.correccionAplicada ?? 'all'}
          onChange={handleCorreccionAplicadaChange}
          label="Corrección (en revisión)">
          <MenuItem value="all">Todas</MenuItem>
          <MenuItem value="true">Aplicada (esperando cierre)</MenuItem>
          <MenuItem value="false">Sin aplicar</MenuItem>
        </Select>
      </FormControl>

      <Button size="small" variant="outlined" onClick={onClear}>
        Limpiar
      </Button>
    </Box>
  )
}

export default SearchFilter
